import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axiosAdmin from "../../../../../api/apiAdmin";
import PriceInfoButton from "../../../../../components/PriceExplain/PriceInfoButton";
import { priceNeedsExplaining } from "../../../../../components/PriceExplain/billedWeight";
import { SelectInput } from "../../../inputComponents/inputcomp";
import { successToast, errorToast } from "../../../toastAlerts/ToastAlerts";
import { useTranslation } from "react-i18next";
import ContinueComponent from "../../../toastAlerts/ContinueComponent";
import PriceAuditModal from "../PriceAudit/PriceAuditModal";
import IncidentModal from "../Incident/IncidentModal";
import IncidentBadge from "../Incident/IncidentBadge";

//icons
import {
    BsBoxArrowInRight,
    BsTrash,
    BsFillPersonFill,
    BsFillEnvelopeFill,
    BsTelephoneFill,
    BsFillHandbagFill,
    BsCalendar,
} from "react-icons/bs";
import { BiPackage, BiPaperPlane, BiSave } from "react-icons/bi";
import {
    FaBarcode,
    FaMoneyBillAlt,
    FaScroll,
    FaTruckMoving,
} from "react-icons/fa";
import { GiWeight } from "react-icons/gi";
import { useContext } from "react";
import { AdminPrimaryContext } from "../../../adminContext/AdminContext";
import { apiError } from "../../../../../api/apiError";

const WarehousePackageItem = ({
    data,
    handleDeletePackage,
    setDifResponses,
    setCheckedAll,
    handleSelectedPackages,
    handleDeleteSelectedPackages,
    handleGiveUserToParcel,
    handleUndeclared,
    currentPlaceType,
}) => {
    //translations
    const { t } = useTranslation();
    //package check
    const [check, setCheck] = useState(false);
    //package data
    const [packData, setPackData] = useState([]);
    //selected flights
    const [selectedFlight, setSelectedFlight] = useState("");
    //dropdown toggler
    const [toggler, setToggler] = useState(false);
    //show contnue
    const [showContinue, setShowContinue] = useState(false);
    //show price audit modal
    const [showPriceAudit, setShowPriceAudit] = useState(false);
    const [showIncident, setShowIncident] = useState(false);
    //data from context
    const { flights } = useContext(AdminPrimaryContext);
    //updated pack values
    const [updatedData, setUpdatedData] = useState({});

    const handleUpdateData = (key, value) => {
        setUpdatedData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    //handle selected flight
    const handleSelectedFlight = (value, inputName) => {
        setSelectedFlight(value);
    };

    //handle checking
    const handleCheck = (e, value) => {
        setCheck(e.target.checked);
        if (e.target.checked) {
            handleSelectedPackages(value);
        } else {
            handleDeleteSelectedPackages(value);
        }
    };

    //check all controller
    useEffect(() => {
        setCheck(setCheckedAll);
        if (setCheckedAll) {
            handleSelectedPackages(data.id);
        } else {
            handleDeleteSelectedPackages(data.id);
        }
    }, [setCheckedAll]);

    //const handle send package
    const handleSend = async () => {
        if (
            parseInt(currentPlaceType) ===
            parseInt(selectedFlight.split("-")[2])
        ) {
            try {
                const res = await axiosAdmin.put(`/packs/${data.id}`, {
                    status: "2",
                    shipment_code: selectedFlight,
                });
                if (res) {
                    successToast(t("success"));
                    setDifResponses(res);
                }
            } catch (err) {
                errorToast(apiError(err, t("error")));
            }
        } else {
            errorToast(
                t(
                    "რეისის ტიპი არ ემთხვევა პაკეტის მოწოდების ტიპს (სახმელეთო,საზღვაო,საჰაერო)"
                )
            );
        }
    };

    const handleRemoveRepack = (id) => {
        axiosAdmin
            .put(`packs/${id}`, { repack: 0 })
            .then((res) => {
                successToast(t("success"));
            })
            .catch((err) => {
                errorToast(t("error"));
            });
    };

    const handleNullifyFine = () => {
        axiosAdmin
            .post(`pack/nojarima/${data.id}`)
            .then((res) => {
                successToast(t("success"));
            })
            .catch((err) => {
                errorToast(t("error"));
            });
    };

    const handleBorderDeclaration = (status) => {
        axiosAdmin
            .put(`/borderDeclaration/${data.id}/${status}`)
            .then((res) => {
                successToast(t("success"));
                setDifResponses(res);
            })
            .catch((err) => {
                errorToast(t("error"));
            });
    };

    //pack items data
    useEffect(() => {
        setPackData(data.packItems);
        handleUpdateData("addon_secur", data.addon_secur);
    }, [data]);

    return (
        <div className={`p-4 rounded-lg dark:bg-slate-700 relative ${
            data.user && data.user.status === 0 ? 'bg-red-200 border-2 border-red-500' :
            (data?.border_declar ?? 0) === 0 ? 'bg-gray-100' :
            (data?.border_declar ?? 0) === 1 ? 'bg-red-100' :
            (data?.border_declar ?? 0) === 2 ? 'bg-green-100' :
            (data?.border_declar ?? 0) === 3 ? 'bg-yellow-100' :
            'bg-white'
        }`}>
            <div className="absolute top-5 right-5">
                <input
                    onChange={(e) => {
                        handleCheck(e, data.id);
                    }}
                    checked={check}
                    type="checkbox"
                    className="w-4 h-4"
                />
            </div>
            <div
                className="w-full flex flex-wrap justify-between pb-2
            gap-y-2 border-b border-gray-200 mb-2"
            >
                <div className="w-[32%] md:w-[49%] sm:w-[100%] flex flex-col gap-y-1">
                    <div className="w-full">
                        <p className="text-[#989ba5] text-[12px]">
                            {t("admin_user_info")}
                        </p>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <BsFillPersonFill className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            {data.user !== undefined &&
                                data.user !== null &&
                                (data.user.company_id === undefined ||
                                data.user.company_id === null ? (
                                    <p className={`text-[12px] font-bold ${data.user.status === 0 ? "text-red-600" : "text-slate-500 dark:text-gray-400"}`}>
                                        {`${data.user.fname_eng || data.user.fname} ${data.user.lname_eng || data.user.lname}`}
                                        {data.user.status === 0 && <span className="ml-1 text-red-600 font-bold">BLACKLISTED</span>}
                                    </p>
                                ) : (
                                    <p className={`text-[12px] font-bold ${data.user.status === 0 ? "text-red-600" : "text-slate-500 dark:text-gray-400"}`}>
                                        {`${data.user.cname_eng || data.user.cname}`}
                                        {data.user.status === 0 && <span className="ml-1 text-red-600 font-bold">BLACKLISTED</span>}
                                    </p>
                                ))}
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <FaBarcode className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p className="text-slate-500 dark:text-gray-400 text-[14px] font-bold">{`id: ${
                                data.user !== undefined &&
                                data.user !== null &&
                                data.user.id
                            }`}</p>
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <BsFillEnvelopeFill className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p className="text-slate-500 dark:text-gray-400 text-[14px] font-bold">
                                {data.user !== undefined &&
                                    data.user !== null &&
                                    data.user.email}
                            </p>
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400  rounded-lg p-2">
                                <BsTelephoneFill className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p className="text-slate-500 dark:text-gray-400 text-[14px] font-bold">
                                {data.user !== undefined &&
                                    data.user !== null &&
                                    data.user.phone}
                            </p>
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <FaMoneyBillAlt className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p
                                className={`text-[14px] font-bold
                        ${
                            data.transport_price === data.transport_paid
                                ? "text-green-400"
                                : "text-red-400"
                        }`}
                            >
                                {t("admin_status")}:{" "}
                                {data.transport_price === data.transport_paid
                                    ? t("admin_paid")
                                    : t("admin_unpaid")}
                            </p>
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <BiPackage className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p
                                className={`text-[14px] font-bold ${
                                    data.repack === 1
                                        ? "text-green-500"
                                        : "text-red-500"
                                }`}
                            >
                                {t("admin_repack_needed")}:{" "}
                                {data.repack === 1 ? t("admin_yes") : t("admin_no")}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="w-[32%] md:w-[49%] sm:w-[100%] flex flex-col gap-y-1">
                    <div className="w-full">
                        <p className="text-[#989ba5] text-[12px]">
                            {t("admin_shipment_info")}
                        </p>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <BiPackage className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p className="text-slate-500 dark:text-gray-400 text-[14px] font-bold">
                                {t("admin_tracking_number")}: {data.tracking_number}
                            </p>
                            <IncidentBadge incident={data.incident} />
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <FaMoneyBillAlt className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p className="text-slate-500 dark:text-gray-400 text-[14px] font-bold">
                                {t("admin_total_amount")}: {data.transport_price.toFixed(2)}
                            </p>
                            {/* The same breakdown the customer sees, so support and
                                customer are never reading two different explanations. */}
                            {priceNeedsExplaining(data) && (
                               <PriceInfoButton
                                  fetcher={() =>
                                     axiosAdmin
                                        .get(`/packs/${data.id}/priceExplain`)
                                        .then(({ data: d }) => d)
                                  }
                               />
                            )}
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <GiWeight className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p className="text-slate-500 dark:text-gray-400 text-[14px] font-bold">
                                {t("admin_total_weight")}: {data.total_weight.toFixed(2)} {t("admin_kg")}
                            </p>
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <FaScroll className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p
                                className={`text-[14px] ${
                                    data.addon_transportation
                                        ? "text-green-500"
                                        : "text-red-500"
                                } `}
                            >
                                {data.addon_secur
                                    ? t("admin_insured")
                                    : t("admin_not_insured")}
                            </p>
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <BsCalendar className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p className="text-slate-500 dark:text-gray-400 text-[14px] font-bold">
                                {t("admin_creation_date")}: {data.created_at}
                            </p>
                        </div>

                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <BsCalendar className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p className="text-slate-500 dark:text-gray-400 text-[14px] font-bold">
                                {t("admin_fine")}: {data.fine_price}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="w-[32%] md:w-[49%] sm:w-[100%] flex flex-col gap-y-1">
                    <div className="w-full">
                        <p className="text-[#989ba5] text-[12px]">
                            {t("admin_shipment_info")}
                        </p>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <FaTruckMoving className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p
                                className={`text-[14px] ${
                                    data.addon_transp
                                        ? "text-green-500"
                                        : "text-red-500"
                                } `}
                            >
                                {t("admin_transport_type")}: <br />{" "}
                                {data.addon_transp ? data.addon_transp : "X"}
                            </p>
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <FaScroll className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            {data.invoice !== "" && data.invoice !== null ? (
                                <Link
                                    to={`${process.env.REACT_APP_API_URL}/storage/${data.invoice}`}
                                    target={"_blank"}
                                >
                                    <p
                                        className={`text-[14px] text-violet-500 underline cursor-pointer`}
                                    >
                                        {t("invoice")}
                                    </p>
                                </Link>
                            ) : (
                                <p
                                    className={`text-[14px] text-red-500 underline cursor-pointer`}
                                >
                                    {t("invoice")}
                                </p>
                            )}
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <BsFillHandbagFill className="w-full h-full dark:text-gray-400 text-slate-500" />
                            </div>
                            <p className="text-slate-500 dark:text-gray-400 text-[14px] font-bold">
                                {t("admin_bag")}: {data.bag}
                            </p>
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <GiWeight className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p className="text-slate-500 dark:text-gray-400 text-[14px] font-bold">
                                {t("admin_volume_weight")}:{" "}
                                {data.volume_weight !== null &&
                                    data.volume_weight.toFixed(2)}{" "}
                                {t("admin_kg")}
                            </p>
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <BsFillPersonFill className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p className="text-slate-500 dark:text-gray-400 text-[14px] font-bold">
                                {t("admin_trusted_person")}: {data.another_person}{" "}
                                {data.another_person_id}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="w-[32%] md:w-[49%] sm:w-[100%] flex flex-col gap-y-1">
                    <SelectInput
                        name={t("admin_flight_info")}
                        handleCarData={handleSelectedFlight}
                        options={flights}
                        value={data.shipment_code}
                    />
                </div>
            </div>
            <div className="flex gap-1 w-full justify-between flex-col sm:gap-y-2">
                <div className="flex flex-col gap-y-1">
                    <p className="text-[#989ba5] text-[12px]">
                        {t("comment")}:
                    </p>
                    <p className="text-gray-400 text-[14px]">{data.comment}</p>
                </div>
                <div className="w-full grid grid-cols-4 sm:grid-cols-1 gap-2">
                    <input
                        placeholder={t("admin_assign_user")}
                        onChange={(e) => {
                            handleUpdateData("userId", e.target.value);
                        }}
                        className="h-10 pl-1.5 focus:outline-none dark:text-white border border-slate-200 rounded-lg dark:bg-slate-800"
                    />
                    <input
                        placeholder={t("admin_weight")}
                        onChange={(e) => {
                            handleUpdateData("weight", e.target.value);
                        }}
                        className="h-10 pl-1.5 focus:outline-none dark:text-white border border-slate-200 rounded-lg dark:bg-slate-800"
                    />
                    <div className="flex gap-2 w-full items-center">
                        <input
                            placeholder={t("admin_length")}
                            onChange={(e) => {
                                handleUpdateData("dementionX", e.target.value);
                            }}
                            className="w-full h-10 pl-1.5 focus:outline-none dark:text-white border border-slate-200 rounded-lg dark:bg-slate-800"
                        />
                        <input
                            placeholder={t("admin_width")}
                            onChange={(e) => {
                                handleUpdateData("dementionY", e.target.value);
                            }}
                            className="w-full h-10 pl-1.5 focus:outline-none dark:text-white border border-slate-200 rounded-lg dark:bg-slate-800"
                        />
                        <input
                            placeholder={t("admin_height")}
                            onChange={(e) => {
                                handleUpdateData("dementionZ", e.target.value);
                            }}
                            className="w-full h-10 pl-1.5 focus:outline-none dark:text-white border border-slate-200 rounded-lg dark:bg-slate-800"
                        />
                    </div>
                    <input
                        placeholder={t("admin_transport_price")}
                        onChange={(e) => {
                            handleUpdateData("transport_price", e.target.value);
                        }}
                        className="h-10 pl-1.5 focus:outline-none dark:text-white border border-slate-200 rounded-lg dark:bg-slate-800"
                    />
                    <input
                        placeholder={t("admin_flight_number_input")}
                        onChange={(e) => {
                            handleUpdateData("flightNumber", e.target.value);
                        }}
                        className="h-10 pl-1.5 focus:outline-none dark:text-white border border-slate-200 rounded-lg dark:bg-slate-800"
                    />
                    <div className="flex items-center gap-2">
                        <input
                            type="checkbox"
                            onChange={(e) => {
                                handleUpdateData(
                                    "addon_secur",
                                    e.target.checked ? 1 : 0
                                );
                            }}
                            checked={updatedData.addon_secur ? true : false}
                        />
                        <p>{t("admin_insurance")}</p>
                    </div>
                    <div
                        onClick={() => {
                            handleGiveUserToParcel(updatedData, data.id);
                        }}
                        className="rounded-lg bg-purple-400 flex items-center justify-center gap-2 px-4 h-10
md:w-full cursor-pointer text-sm "
                    >
                        <BiSave className="text-white font-bold" />
                        <p className="text-white font-bold">{t("admin_memorize")}</p>
                    </div>
                    {data.repack !== 0 && (
                        <div
                            onClick={() => {
                                handleRemoveRepack(data.id);
                            }}
                            className="rounded-lg bg-green-400 flex items-center justify-center gap-2 px-4 h-10
md:w-full cursor-pointer text-sm "
                        >
                            <p className="text-white font-bold">
                                {t("admin_remove_repack")}
                            </p>
                        </div>
                    )}
                </div>
                <div className="w-full grid grid-cols-4 sm:grid-cols-1 gap-2">
                    <div
                        onClick={handleSend}
                        className="rounded-lg bg-green-400 flex items-center justify-center gap-2 px-4 h-10 w-full cursor-pointer"
                    >
                        <BiPaperPlane className="text-white font-bold" />
                        <p className="text-white font-bold">{t("admin_send_selected")}</p>
                    </div>
                    {data.packItems !== null && data.packItems.length !== 0 && (
                        <div
                            onClick={() => {
                                handleUndeclared(data.id);
                            }}
                            className="rounded-lg bg-purple-400 flex items-center justify-center gap-2 px-4 h-10 w-full cursor-pointer"
                        >
                            <p className="text-white font-bold">
                                {t("admin_delete_declaration")}
                            </p>
                        </div>
                    )}
                    <div className="relative">
                        <div
                            onClick={() => {
                                setToggler(true);
                            }}
                            className="rounded-lg bg-yellow-400 flex items-center justify-center gap-2 px-4 h-10 w-full cursor-pointer"
                        >
                            <BsBoxArrowInRight className="text-white font-bold" />
                            <p className="text-white font-bold">{t("admin_details")}</p>
                        </div>
                        {toggler && (
                            <div
                                className="w-[300px] h-52 absolute bottom-[100%] left-0 p-2 rounded-lg sm:w-full border border-slate-500 bg-white
                            pt-10 overflow-auto scrollbar  dark:bg-slate-700 z-50"
                            >
                                <div
                                    onClick={() => {
                                        setToggler(false);
                                    }}
                                    className="w-6 h-6 rounded-full bg-red-400 flex items-center justify-center cursor-pointer
                                    absolute top-2 right-2"
                                >
                                    <p className="text-white font-bold">X</p>
                                </div>
                                {packData.map((item) => {
                                    return (
                                        <div
                                            key={item.id}
                                            className="border border-slate-400 rounded-lg p-3 flex justify-between items-center mt-2"
                                        >
                                            <p className="text-sm text-gray-400">{`(${item.product_id}) ${item.name}`}</p>
                                            <p className="text-sm text-gray-400">{`${item.price}`}</p>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                    <div
                        onClick={() => {
                            setShowContinue(true);
                        }}
                        className="w-full h-10 rounded-lg bg-red-400 flex items-center justify-center cursor-pointer"
                    >
                        <BsTrash className="text-white font-bold" />
                        <p className="text-white font-bold">{t("delete")}</p>
                    </div>

                    <div
                        onClick={() => {
                            handleNullifyFine();
                        }}
                        className="w-full h-10 rounded-lg bg-blue-600 flex items-center justify-center cursor-pointer"
                    >
                        <p className="text-white font-bold">{t("admin_reset_fine")}</p>
                    </div>

                    <div
                        onClick={() => setShowPriceAudit(true)}
                        className={`w-full h-10 rounded-lg flex items-center justify-center cursor-pointer ${
                            data.price_locked ? "bg-red-500" : "bg-indigo-500"
                        }`}
                        title={
                            data.price_locked
                                ? `Locked at ${data.price_lock_amount} (${data.price_lock_scope})`
                                : "Open price history & lock controls"
                        }
                    >
                        <p className="text-white font-bold">
                            {data.price_locked ? "🔒 " : ""}
                            {t("admin_price_history") || "Price history & lock"}
                        </p>
                    </div>
                    <div
                        onClick={() => !data.incident && setShowIncident(true)}
                        title={data.incident ? data.incident.reason : "დაზიანდა / დაიკარგა"}
                        className={`h-10 rounded-lg flex items-center justify-center px-2 ${
                            data.incident ? "bg-slate-400 cursor-default" : "bg-red-600 cursor-pointer"
                        }`}
                    >
                        <p className="text-white font-bold">
                            {data.incident ? `${data.incident.type_label || ""} ✓` : "დაზიანდა / დაიკარგა"}
                        </p>
                    </div>
                </div>
                <div className={`w-full grid grid-cols-4 sm:grid-cols-1 gap-2 mt-2 p-3 rounded-lg ${
                    (data?.border_declar ?? 0) === 0 ? 'bg-gray-200' :
                    (data?.border_declar ?? 0) === 1 ? 'bg-red-200' :
                    (data?.border_declar ?? 0) === 2 ? 'bg-green-200' :
                    (data?.border_declar ?? 0) === 3 ? 'bg-yellow-200' :
                    'bg-white'
                }`}>
                    <p className="text-[#989ba5] text-[12px] col-span-4">სამეფო დეკლარაციის სტატუსი:</p>
                    <div
                        onClick={() => {
                            handleBorderDeclaration(0);
                        }}
                        className={`w-full h-10 rounded-lg flex items-center justify-center cursor-pointer font-bold transition-colors ${
                            data.border_declar === 0
                                ? "bg-gray-500 text-white"
                                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                        }`}
                    >
                        <p>{t("admin_declar_not_needed")}</p>
                    </div>
                    <div
                        onClick={() => {
                            handleBorderDeclaration(1);
                        }}
                        className={`w-full h-10 rounded-lg flex items-center justify-center cursor-pointer font-bold transition-colors ${
                            data.border_declar === 1
                                ? "bg-red-600 text-white"
                                : "bg-red-200 text-red-700 hover:bg-red-300"
                        }`}
                    >
                        <p>{t("admin_declar_red")}</p>
                    </div>
                    <div
                        onClick={() => {
                            handleBorderDeclaration(2);
                        }}
                        className={`w-full h-10 rounded-lg flex items-center justify-center cursor-pointer font-bold transition-colors ${
                            data.border_declar === 2
                                ? "bg-green-600 text-white"
                                : "bg-green-200 text-green-700 hover:bg-green-300"
                        }`}
                    >
                        <p>{t("admin_declar_green")}</p>
                    </div>
                    <div
                        onClick={() => {
                            handleBorderDeclaration(3);
                        }}
                        className={`w-full h-10 rounded-lg flex items-center justify-center cursor-pointer font-bold transition-colors ${
                            data.border_declar === 3
                                ? "bg-yellow-500 text-white"
                                : "bg-yellow-200 text-yellow-700 hover:bg-yellow-300"
                        }`}
                    >
                        <p>{t("admin_declar_yellow")}</p>
                    </div>
                </div>
            </div>
            <ContinueComponent
                showFlag={showContinue}
                actionFunction={handleDeletePackage}
                id={data.id}
                setShowContinue={setShowContinue}
            />
            {showPriceAudit && (
                <PriceAuditModal
                    pack={data}
                    onClose={() => setShowPriceAudit(false)}
                    onUpdated={() => setDifResponses && setDifResponses((p) => !p)}
                />
            )}
            {showIncident && (
                <IncidentModal
                    pack={data}
                    onClose={() => setShowIncident(false)}
                    onDone={() => setDifResponses && setDifResponses((p) => !p)}
                />
            )}
        </div>
    );
};
export default WarehousePackageItem;
